import { UserPayload } from '@core/helpers/user-helper';
const auth_local_storage_key = 'Saturn_Token';
const richTablePreferences_key = 'RichTablePreferences';

function base64Decode(val: string): string {
	const base64 = val.replace(/-/g, '+').replace(/_/g, '/');
	return decodeURIComponent(
		atob(base64)
			.split('')
			.map(function (c) {
				return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
			})
			.join(''),
	);
}

function parseJwt(token: string): UserPayload | null {
	if (token) {
		const jsonPayload = base64Decode(token.split('.')[1]);
		return new UserPayload(JSON.parse(jsonPayload));
	} else return null;
}

function logout(redirectToLogin = true): void {
	localStorage.removeItem(auth_local_storage_key);
	localStorage.removeItem(richTablePreferences_key);

	if (redirectToLogin) {
		localStorage.setItem('redirect-path-after-login', window.location.href);
		window.location.href = '/login';
	}
}

function checkToken(): boolean {
	const authToken = auth.getToken();
	if (!authToken) {
		logout(true);
		return false;
	} else return true;
}

interface IAuth {
	key: string;
	checkToken: () => boolean;
	getToken: () => string | null;
	getTokenPayload: () => UserPayload | null;
	logout: (redirectToLogin?: boolean) => void;
}

const auth: IAuth = {
	key: auth_local_storage_key,
	checkToken,
	getToken: () => localStorage.getItem(auth_local_storage_key),
	getTokenPayload: () => {
		checkToken();
		return parseJwt(auth.getToken());
	},
	logout,
};

export default auth;
